<template>
  <div>
    <div id="target" class="about">
    <el-row class='main-body' id="lxwm">
      <el-col style="text-align: left;" :span="16" :offset="4">
        <el-row >
          <el-col style="text-align: left">
            <h2  class="info-main" style="font-size: 25px;">{{ $t('default.contact_us') }}</h2>
            <p class="info-p">
              {{$t('default.project_email')}}：rlrl.rws@polyu.edu.hk
            </p>
            <p class="info-p">
              {{$t('default.inquiries')}}

            </p>
            <p class="info-p">
              {{$t('default.complaints')}}
            </p>
          </el-col>
          </el-row>
      </el-col>
    </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="less">
.about {
  background-image: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5)), url('../../assets/banner3.jpg');
  background-size: cover;
  height: 100vh;
  padding-top: 50px;
  .info-main {
    display: inline-block;
    font-weight: 800;
    margin-bottom: 30px;
    font-style: normal;
    color: #111827;
    font-size: 30px;
    line-height: 38px;
  }
  .info-title {
    font-weight: 800;
    background: #111827;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-right: .2rem;
    padding-bottom: .4rem;
  }
  .info-p {
    font-size: 16px;
    line-height: 30px;
    color: #000;
    display: block;
  }
}
</style>